import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription, interval } from 'rxjs';
import { RequestsHelpModalComponent } from "../../components/requests-help-modal/requests-help-modal.component";
import { ReferencesHelpModalComponent } from "../../components/references-help-modal/references-help-modal.component";
import { RequestsService } from "../../services/requests/requests.service";
import { RequestsPulseService } from "../../services/requests/requests-pulse.service";
import { OrganisationService } from "../../services/organisation/organisation.service";
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import { PermissionsService } from "../../services/permissions/permissions.service";
import { ReferenceModalComponent } from 'src/app/components/reference-modal/reference-modal.component';
import { ReferencesService } from 'src/app/services/references/references.service';
import { PulsesHelpModalComponent } from 'src/app/components/pulses-help-modal/pulses-help-modal.component';
import { environment } from 'src/environments/environment';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import {ChecksHelpModalComponent} from "../../components/checks-help-modal copy/checks-help-modal.component";
import {TrustMarketplaceStatusService} from "../../services/trust-marketplace-status/trust-marketplace-status.service";

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.pug',
  styleUrls: ['./requests.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class RequestsComponent implements OnInit, OnDestroy {
  requestsData: any;
  moment: any;
  loading = true;
  pageType = '';
  tabRedirected: boolean = false;
  selectedColumns: any = [];
  searchOption: any = undefined;
  searchOptionsExits = [{ 'label': $localize`Ex-employee`, 'hint': $localize`First or last name`, 'value': 'name' }, { 'label': $localize`Email`, 'hint': $localize`Email address`, 'value': 'email' }, { 'label': $localize`Survey`, 'hint': $localize`Survey title`, 'value': 'questionnaire' }];
  searchOptionsReferences = [{ 'label': $localize`Candidate`, 'hint': $localize`First or last name`, 'value': 'name' }, { 'label': $localize`Email`, 'hint': $localize`Email address`, 'value': 'email' }, { 'label': $localize`Survey`, 'hint': $localize`Survey title`, 'value': 'questionnaire' }];
  searchOptionsPulses = [{ 'label': $localize`Request`, 'hint': $localize`Request`, 'value': 'Request' }, { 'label': $localize`Created by`, 'hint': $localize`First or last name`, 'value': 'created_by' }, { 'label': $localize`Last updated by`, 'hint': $localize`First or last name`, 'value': 'last_updated_by' }];
  searchOptionsChecks = [{ 'label': $localize`Recipient`, 'hint': $localize`First or last name`, 'value': 'candidate' }, { 'label': $localize`Requested by`, 'hint': $localize`First or last name`, 'value': 'name' }, { 'label': $localize`Vendor`, 'hint': $localize`Vendor name`, 'value': 'vendor' }, { 'label': $localize`Check name`, 'hint': $localize`Check name`, 'value': 'check' }];
  searchOptions = this.searchOptionsExits
  sortString = '-created';
  sortOptions = [
    {
      'label': $localize`Requested date`,
      'type': "number",
      'value': "created"
    },
    {
      'label': $localize`Employee`,
      'type': "word",
      'value': "name"
    }
  ];
  sortPulseOptions = [
    {
      'label': $localize`Request`,
      'type': "word",
      'value': "request"
    },
    {
      'label': $localize`Created by`,
      'type': "word",
      'value': "created_by"
    },
    {
      'label': $localize`Updated by`,
      'type': "word",
      'value': "updated_by"
    },
    {
      'label': $localize`Send date`,
      'type': "number",
      'value': "send_date"
    },
    {
      'label': $localize`Cutoff date`,
      'type': "number",
      'value': "cutoff_date"
    }
  ];
  filterCheckboxTitle = $localize`Requested by`;
  filterCheckboxOptions = [
    { 'label': $localize`Only me`, 'value': 'me' }
  ];
  filterStatusTitle = $localize`Request status`;
  filterStatusOptions = [
    { 'label': $localize`Invited`, 'value': 'Invited' },
    { 'label': $localize`In progress`, 'value': 'In progress' },
    { 'label': $localize`Submitted`, 'value': 'Submitted' },
    { 'label': $localize`Verified`, 'value': 'Verified' },
    { 'label': $localize`Declined`, 'value': 'Declined' },
    { 'label': $localize`Expired`, 'value': 'Expired' }
  ];
  filterByOptions = [{ 'key': 'Requested date', 'value': $localize`Requested date` }, { 'key': 'Last activity', 'value': $localize`Last activity` }];
  filterDefaults = [{ 'key': 'Requested date', 'value': $localize`Requested date` }];
  filterOutput: any;
  filterByVar = 'Requested date'
  filterType = 'All';
  selectedTab = 'exit';
  total = 5;
  rowsPerView = 20;
  currentPage = 1;
  noDataReferences = false;
  noFilterData = false;
  noDataChecks = false;
  noDataExits = false;
  noDataPulses = false;
  requestsHelpModal: BsModalRef;
  originPage = 'Request';
  displayBanner = false;
  initialDataRequest = true;
  addOrder = 0;
  deleteRequestWarningModal: BsModalRef = new BsModalRef();
  referenceModal: BsModalRef = new BsModalRef();
  exitsTabAvailable = false;
  pulsesTabAvailable = false;
  pulseListProject = true;
  updatedPermissionsFetched = true;
  engageUrl = environment.ENGAGE_URL;
  page = '';
  ref_id: string;
  deleteorstopReferenceId: any;
  comingSoon = $localize`Coming soon`;
  BackGroundSearchOptions: any ;
  start;
  end;
  hasBackgroundCheckPermissions = false;

  tmpAdminStatus: number | undefined = 1;
  TrustEIVC = false;
  canViewReferenceTab = false;
  canViewPulseTab = false;
  canViewExitTab = false;
  canViewBackgroundCheckTab = false;
  ENT_INTERNAL_REF_FF = false;
  get heading() { return this.selectedTab !== 'backGroundCheck' ? $localize`Request access to ${this.capitalizeFirstLetter(this.selectedTab)} requests` : $localize`Request access to Background check requests`; }
  subHeading = $localize`Access this page upon being granted permission.`;
  btnText = $localize`Request access`;
  searchTags: any = [];
  searchTitle = ConstantsService.searchTitle;
  searchDescription = ConstantsService.searchDescription;
  searchImg = ConstantsService.searchImg;
  products = ConstantsService.rolesPermissionProducts;
  canViewFilterAndSearch = false;
  ENT_9003_FE_REQUESTS_PERSISTENT_DATA = false;

  // Background refresh
  private readonly BACKGROUND_REFRESH_INTERVAL = 60 * 1000; // 1 minute
  private backgroundRefreshSubscription: Subscription | null = null;
  backgroundRefreshCounter = 0;

  constructor(
    private modalService: BsModalService,
    public alertList: AlertBannerService,
    private router: Router,
    private referencesService: ReferencesService,
    private permissions: PermissionsService,
    public organisation: OrganisationService,
    private requests: RequestsService,
    private requestsPulse: RequestsPulseService,
    private trustMarketplaceStatusService: TrustMarketplaceStatusService,
  ) {
    let originPage = this.router.getCurrentNavigation()?.extras?.state?.originPage;
    if (originPage) {
      this.originPage = originPage;
    }
    this.requestsHelpModal = new BsModalRef();
    this.page = this.router.getCurrentNavigation()?.extras?.state?.from;
    this.ref_id = this.router.getCurrentNavigation()?.extras?.state?.checkId;
  }

  ngOnInit(): void {
    this.fetchTrustMarketplaceStatus()
    this.ENT_INTERNAL_REF_FF = this.permissions.isFeatureActivated('ENT-9344-INTERNAL-REFERENCE-FF');
    this.TrustEIVC = this.permissions.isFeatureActivated('trust-892-eivc');
    this.ENT_9003_FE_REQUESTS_PERSISTENT_DATA = this.permissions.isFeatureActivated('ent-9003-fe-requests-persistent-data');
    this.sortOptions[0] = { ...this.sortOptions[0], label: $localize`Send date` }
    this.pulsesTabAvailable = true;
    this.exitsTabAvailable = true;
    this.selectedTab = 'reference';
    if (this.ENT_INTERNAL_REF_FF && this.selectedTab === 'reference') {
      this.searchOptionsReferences.push({ 'label': $localize`Internal reference`, 'hint': $localize`Internal reference`, 'value': 'internal_reference' });
    }

    this.bannerShowStates();
    if (this.page === 'lifeCyclePage' || this.page === 'referenceReportPage') {
      this.selectedTab = 'reference';
      this.onViewReport(this.ref_id)
    }
    this.retrieveSearchAndFilter();

    let selectedTab = localStorage.getItem('requests-page-selected-tab');
    if (selectedTab) {
      this.selectedTab = selectedTab;
      if (selectedTab === "pulse") this.sortString = "-send_date"
      if (selectedTab === "backGroundCheck") this.sortString = "-created"
    }
    this.permissions.setNavCheck(true);
    // selectedTab is update above.
    this.updateTabViewPermissions();
    this.loading = false;

    // Start background refresh if feature flag is enabled
    this.startBackgroundRefresh();
  }

  ngOnDestroy(): void {
    this.stopBackgroundRefresh();
  }

  private startBackgroundRefresh(): void {
    if (!this.ENT_9003_FE_REQUESTS_PERSISTENT_DATA) {
      return;
    }

    this.backgroundRefreshSubscription = interval(this.BACKGROUND_REFRESH_INTERVAL).subscribe(() => {
      this.triggerBackgroundRefresh();
    });
  }

  private stopBackgroundRefresh(): void {
    if (this.backgroundRefreshSubscription) {
      this.backgroundRefreshSubscription.unsubscribe();
      this.backgroundRefreshSubscription = null;
    }
  }

  private triggerBackgroundRefresh(): void {
    // Only clear cache for the active tab's service to avoid unnecessary operations
    switch (this.selectedTab) {
      case 'reference':
        this.referencesService.clearCache();
        break;
      case 'exit':
        this.requests.clearCache();
        break;
      case 'pulse':
        this.requestsPulse.clearCache();
        break;
      case 'backGroundCheck':
        // Background checks don't have service-level caching implemented yet
        break;
    }

    // Increment counter to trigger ngOnChanges in child components. This uses the rxjs interval to trigger the refresh.
    this.backgroundRefreshCounter++;
  }

  private updateTabViewPermissions() {
    this.canViewReferenceTab = (this.permissions.hasPermission('can_view_reference_requests_list') || this.permissions.hasPermission('can_view_reference_requests_list_with_survey_perms') || this.permissions.hasPermission('can_view_own_reference_requests_list') || this.permissions.hasPermission('can_view_integrationuser_requests_list') || this.permissions.hasPermission('can_view_integrationuser_requests_list_restricted'));
    this.canViewPulseTab = (this.permissions.hasPermission('can_view_pulse_requests_list') || this.permissions.hasPermission('can_view_pulse_requests_list_with_survey_perms') || this.permissions.hasPermission('can_view_own_pulse_requests_list'));
    this.canViewExitTab = (this.permissions.hasPermission('can_view_exit_requests_list') || this.permissions.hasPermission('can_view_exit_requests_list_with_survey_perms') || this.permissions.hasPermission('can_view_own_exit_requests_list'));
    this.canViewBackgroundCheckTab = (this.permissions.hasPermission('can_view_backgroundcheck_requests_list') || this.permissions.hasPermission('can_view_backgroundcheck_requests_list_with_survey_perms') || this.permissions.hasPermission('can_view_own_backgroundcheck_requests_list'));
    this.canViewFilterAndSearch =  (this.selectedTab === 'pulse' && this.canViewPulseTab) || (this.selectedTab === 'exit' && this.canViewExitTab) || (this.selectedTab === 'reference' && this.canViewReferenceTab) || (this.selectedTab === 'backGroundCheck' && this.canViewBackgroundCheckTab);
  }

  bannerShowStates() {
    if (this.originPage === 'success') {
      this.alertList.append([{
      type: AlertType.SUCCESS,
      message: $localize`We are working our magic to process your requests. They will appear in the list below momentarily.`,
      timeout: 5000,
      keepOnRouteChange: true
        }]);
    }
    this.router.navigate(['requests'], { queryParams: { originPage: 'Request' } });
  }

  hideResponseCount() {
    this.displayBanner = false;
  }

  onSelectTab(event) {
    if (this.selectedTab != event.id) {
      if (this.ENT_9003_FE_REQUESTS_PERSISTENT_DATA) {
        // Only re-fetch permissions if they haven't been loaded yet
        if (!this.permissions.data || Object.keys(this.permissions.data).length === 0) {
          this.loading = true;
          this.updatedPermissionsFetched = false;
          this.permissions.initializePermissions().then(() => {
            this.updateTabViewPermissions();
            this.loading = false;
            this.updatedPermissionsFetched = true;
          });
        } else {
          // Permissions already loaded, just update tab view permissions
          this.updateTabViewPermissions();
        }
      } else {
        // Original behavior: always re-fetch permissions on tab switch
        this.loading = true;
        this.updatedPermissionsFetched = false;
        this.permissions.initializePermissions().then(() => {
          this.updateTabViewPermissions();
          this.loading = false;
          this.updatedPermissionsFetched = true;
        });
      }
    }

    if (this.selectedTab !== event.id) {
      this.currentPage = 1;
    }
    this.selectedTab = event.id;
    if (localStorage.getItem('requests-page-selected-tab')) {
      if (localStorage.getItem('requests-page-selected-tab') != event.id) {
        this.sortString = event.id == "pulse" ? '-send_date' : '-created'
      }
    }
    switch (this.selectedTab) {
      case 'reference':
        this.filterByVar = 'Send date'
        this.filterCheckboxTitle = $localize`Refine by`;
        this.filterCheckboxOptions = [
          { 'label': $localize`My requests`, 'value': 'me' },
          { 'label': $localize`Unread requests`, 'value': 'unread_only' }
        ];

        this.searchOptions = this.searchOptionsReferences
        this.filterByOptions = [
            { key: 'Send date', value: $localize`Send date` }
        ];
        this.filterStatusOptions = [
          {'label': $localize`Requested`, 'value': 'Requested'},
          {'label': $localize`In progress`, 'value': 'In progress'},
          {'label': $localize`Completed`, 'value': 'Completed'},
          {'label': $localize`Stopped`, 'value': 'Stopped'},
          {'label': $localize`Expired`, 'value': 'Expired'}
        ];
        this.tabRedirected = false;
        break;
      case 'backGroundCheck':
        this.filterCheckboxTitle = $localize`Requested by`;
        this.filterCheckboxOptions = [];
        this.searchOptions = this.searchOptionsChecks
        this.filterByOptions = [
          { key: 'Send date', value: $localize`Send date` },
        ];
        this.filterByVar = 'Send date'
        this.filterStatusTitle = $localize`Status`
        if(this.TrustEIVC){
            this.filterStatusOptions = [
              { 'label': $localize`Sending`, 'value': 'Sending' },
              { 'label': $localize`In progress`, 'value': 'In progress' },
              { 'label': $localize`Completed`, 'value': 'Completed' },
              { 'label': $localize`Error`, 'value': 'Failed' },
              { 'label': $localize`Expired`, 'value': 'Expired' },
              { 'label': $localize`Cancelled`, 'value': 'Cancelled' },
              { 'label': $localize`Declined`, 'value': 'Declined' },

            ];
        }
        else{
            this.filterStatusOptions = [
              { 'label': $localize`Sending`, 'value': 'Sending' },
              { 'label': $localize`In progress`, 'value': 'In progress' },
              { 'label': $localize`Completed`, 'value': 'Completed' },
              { 'label': $localize`Failed`, 'value': 'Failed' },
              { 'label': $localize`Expired`, 'value': 'Expired' },
              { 'label': $localize`Cancelled`, 'value': 'Cancelled' },
              { 'label': $localize`Declined`, 'value': 'Declined' },

            ];
        }

        break;
      case 'exit':
        this.filterByVar = 'Requested date'
        this.filterCheckboxTitle = $localize`Requested by`;
        this.filterCheckboxOptions = [
          { 'label': $localize`Only me`, 'value': 'me' }
        ];
        this.searchOptions = this.searchOptionsExits
        this.filterByOptions = [
          { key: 'Send date', value: $localize`Send date` },
          { key: 'Last activity', value: $localize`Last activity` },
        ];
        this.filterByVar = 'Send date'
        this.filterStatusOptions = [
          { 'label': $localize`Invited`, 'value': 'Invited' },
          { 'label': $localize`In progress`, 'value': 'In progress' },
          { 'label': $localize`Submitted`, 'value': 'Submitted' },
          { 'label': $localize`Verified`, 'value': 'Verified' },
          { 'label': $localize`Declined`, 'value': 'Declined' },
          { 'label': $localize`Expired`, 'value': 'Expired' }
        ];
        this.filterCheckboxOptions[0].label = $localize`My requests`;
        this.filterCheckboxTitle = $localize`Refine by`;
        this.filterCheckboxOptions.push({ 'label': $localize`Unread requests`, 'value': 'unread_only' });
        this.tabRedirected = false;
        break;
      case 'pulse':
        if (this.filterByVar.toLowerCase().includes('last')) {

        } else {
          this.filterByVar = 'Cutoff date'
        }
        this.filterCheckboxTitle = $localize`Refine by`
        this.filterCheckboxOptions = [{ 'label': $localize`Insights available`, 'value': 'insights_available' }];
        this.filterByOptions = [{ 'key': 'Cutoff date', 'value': $localize`Cutoff date` }, { 'key': 'Last activity', 'value': $localize`Last activity` }];
        this.filterStatusOptions = [
          { 'label': $localize`Scheduled`, 'value': 'Scheduled' },
          { 'label': $localize`Sending`, 'value': 'Sending' },
          { 'label': $localize`In progress`, 'value': 'pulseInprogress' },
          { 'label': $localize`Completed`, 'value': 'Completed' },
          { 'label': $localize`Stopped`, 'value': 'Stopped' },
          { 'label': $localize`Cancelled`, 'value': 'Cancelled' }
        ];
        this.searchOptions = this.searchOptionsPulses
        this.sortPulseOptions = this.sortPulseOptions
        this.tabRedirected = false;
        break;
      default:
        this.searchOptions = this.searchOptionsExits
        break;
    }
    localStorage.setItem('requests-page-selected-tab', this.selectedTab);
    this.retrieveSearchAndFilter();
  }

  public openEngageUrl() {
    window.open(this.engageUrl + ConstantsService.ENGAGE_UTM_URL, "_blank");
    return;
  }

  createSearchOption(): { key: string; value: string }[] {
    return this.searchTags.map(item => ({
      key: item.value === '' ? 'all' : item.value,
      value: item.term
    }));
  }

  onSearchChange(searchOutput) {
    this.searchTags = [...this.searchTags]
    this.searchTags.unshift(searchOutput)
    this.searchOption = this.createSearchOption()

    this.pageType = 'view_requests';
    this.storeSearch();
    this.onSelectTab({ "id": this.selectedTab });
    this.currentPage = 1
  }


  onRemoveSearchTag(searchOutput){
    this.searchTags = searchOutput
    this.searchOption = this.createSearchOption()
    this.pageType = 'view_requests';
    this.storeSearch();
    this.onSelectTab({ "id": this.selectedTab });
    this.currentPage = 1
  }

  retrieveSearchAndFilter() {
    let storedSearch = localStorage.getItem(`${this.selectedTab}_search`);
    if (storedSearch) {
      let storedSearchJson = JSON.parse(storedSearch);
      this.searchOption = storedSearchJson['searchOption'];
      this.selectedColumns = storedSearchJson['selectedColumns'];
      this.pageType = storedSearchJson['pageType'];
      this.addOrder = storedSearchJson['addOrder'];
      this.searchTags = storedSearchJson?.searchTags || [];
      if(this.searchTags && this.searchTags.length === 0){
        this.searchOption = []
      }
    }
    else {
      this.selectedColumns = [];
      this.searchOption = [];
      this.pageType = 'view_requests';
      this.searchTags = [];
    }
    let filtersJson: any = JSON.parse(localStorage.getItem(`${this.selectedTab}_filters`) as any);
    if (filtersJson) {
      this.filterOutput = {...filtersJson,
        filterBy: filtersJson.filterByVar,
        statusOption: filtersJson.statusOption
      };
      this.filterType = filtersJson.filter;
      this.filterByVar = filtersJson.filterByVar;
    }
  }

  storeSearch(tab=this.selectedTab) {
    const dumped_data = {
      searchOption: this.searchOption,
      selectedColumns: this.selectedColumns,
      addOrder: this.addOrder,
      pageType: this.pageType,
      searchTags: this.searchTags
    }
    localStorage.setItem(`${tab}_search`, JSON.stringify(dumped_data));

  }

  saveFilters(event, tab=this.selectedTab) {
    const filters = JSON.stringify(event)
    localStorage.setItem(`${tab}_filters`, filters)
  }

  onSortChange(sortString: string): void {
    this.sortString = sortString;
    this.onSelectTab({ "id": this.selectedTab });
  }

  onFilterUpdate(event) {
    this.filterOutput = event;
    this.saveFilters(event);
    this.filterOutput.filterBy = event.filterByVar
    this.filterByVar = event.filterByVar
    this.filterType = event.filter;
    if (this.selectedTab === 'reference') {
      this.noDataReferences = false;
    }
    this.onSelectTab({ "id": this.selectedTab });
    this.filterByVar = event.filterByVar;
    this.currentPage = 1
  }

  onFilterReset() {
    this.filterOutput = null;
    this.filterType = 'All'
    this.onSelectTab({ "id": this.selectedTab });
  }

  onPageChange(pageNumber) {
    if (this.currentPage !== pageNumber) {
      this.currentPage = pageNumber;
      this.onSelectTab({ "id": this.selectedTab });
    }
  }

  onPageSizeChange(rowsPerView) {
    this.rowsPerView = rowsPerView;
    this.currentPage = 1;
    this.onSelectTab({ "id": this.selectedTab });
  }

  onViewReport(id) {
    if (this.selectedTab === 'reference') {
      this.loading = true
      this.referencesService.getCheck(id).subscribe(
        res => {
          this.loading = false;
          const initialState = {
            'check': res
          }
          this.referenceModal = this.modalService.show(ReferenceModalComponent, {
            class: 'modal-dialog-scrollable reference-modal', initialState
          })
          this.referenceModal.content.deleteorstopAction.subscribe(checkId => {
            this.deleteorstopReferenceId = checkId;
          });
        },
        error => {
          console.log(error);
          this.loading = false;
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        });
    } else {
      this.router.navigate([`/report/${id}`]);
    }
  }

  showHelp() {
    if (this.selectedTab === 'reference') {
      this.requestsHelpModal = this.modalService.show(ReferencesHelpModalComponent, {
        class: 'modal-dialog-centered modal-lg'
      });
    }
    else if (this.selectedTab === 'pulse') {
      this.requestsHelpModal = this.modalService.show(PulsesHelpModalComponent, {
        class: 'modal-dialog-centered xl-popup'
      });
    }else if (this.selectedTab === 'backGroundCheck') {
      this.requestsHelpModal = this.modalService.show(ChecksHelpModalComponent, {
        class: 'modal-dialog-centered modal-lg'
      });
    }else {
      this.requestsHelpModal = this.modalService.show(RequestsHelpModalComponent, {
        class: 'modal-dialog-centered modal-lg'
      });
    }
  }
  resetAllFilters() {
    this.filterOutput = null;
    this.filterType = 'All'
    this.onSelectTab({ "id": this.selectedTab });
  }

  fetchTrustMarketplaceStatus() {
    this.trustMarketplaceStatusService.trustStatus$.subscribe(
      res => {
        this.hasBackgroundCheckPermissions = res === ConstantsService.TRUST_MARKET_PLACE_STATUSES.connected;
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
    this.trustMarketplaceStatusService.trustAdminStatus.subscribe(
      res => {
        if (res != undefined) {
          this.tmpAdminStatus = res;
        }
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );


  }

  receiveLoading(loading) { this.loading = loading; }
  receiveTotal(total) { this.total = total; }
  receiveNoDataReferences(noDataReferences) { this.noDataReferences = noDataReferences; }
  receiveNoFilterData(noFilterData) { this.noFilterData = noFilterData; }
  receiveNoDataChecks(noDataChecks) { this.noDataChecks = noDataChecks; }
  receiveNoDataPulses(noDataPulses) { this.noDataPulses = noDataPulses; }
  receiveNoDataExits(noDataExits) { this.noDataExits = noDataExits; }
  receiveSortOptions(sortOptions) { this.sortOptions = sortOptions; }
  receiveSortPulseOptions(sortOptions) { this.sortPulseOptions = sortOptions; }
  receiveFilterStatusOptions(filterStatusOptions) { this.filterStatusOptions = filterStatusOptions; }
  receiveBackGroundSearchOptions(backGroundSearchOptions) {
    this.BackGroundSearchOptions = backGroundSearchOptions;
    this.selectedTab = 'backGroundCheck';
    this.tabRedirected = true;
    const customData = {
      checkboxOption: ['all'],
      department_category_id: 'all',
      filter: "Custom",
      filterBy: 'Requested date',
      filterByVar: 'Send date',
      statusOption: [],
      start_date: backGroundSearchOptions['startDate'],
      end_date: backGroundSearchOptions['endDate']
    }
    const searchChange = {
        data: {
          addOrder: 1,
          chips: [
            {
              addOrder: 2,
              label: "All",
              searchValue: backGroundSearchOptions['recipientName'],
              value: "all"
            }
          ],
          search: [
            {
              key: "all",
              value: backGroundSearchOptions['recipientName']
            }
          ],
        }
      }
    this.filterOutput = customData;
    this.filterOutput.filterBy = customData.filterByVar
    this.filterType = customData.filter;
    this.filterByVar = customData.filterByVar;


    if (this.selectedColumns.length > 0 && this.selectedColumns[0].label == "Candidate" && this.selectedTab == "backGroundCheck"){
      this.selectedColumns[0].label = "Recipient"
    }


    this.saveFilters(this.filterOutput, "backGroundCheck")
    this.storeSearch("backGroundCheck")

    this.onSelectTab({ "id": this.selectedTab });
    this.currentPage = 1
    this.filterType = "Custom"
    this.start = backGroundSearchOptions['startDate']
    this.end = backGroundSearchOptions['endDate']
  }

  capitalizeFirstLetter(value: string): string {
    if (!value) return value;
    return ConstantsService.REQUEST_SELECTED_TABS[value];
  }

  onRequestAccess($event: any, product: string) {
    this.permissions.requestAccess(
      {
        product: product,
        template_type: 'hybrid'
      }
    ).subscribe(
      (res) => {
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Your request has been sent successfully. You will be notified once your request has been approved.`,
          keepOnRouteChange: true
        }]);
      },
      (error) => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    )
  }
}
